import { SubmittalModel } from "./Submittal.model";

export class Submittal extends SubmittalModel {
    // Add custom methods here
}
